module.exports = __webpack_public_path__ + "img/cotizacion_1.9efacd34.png";